import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketStatusResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketStatusUseCase = async (
  ticketId: string,
  newStatus: string,
): Promise<PatchTicketStatusResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketStatus(
      namespace,
      ticketId,
      newStatus,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update ticket status")
        .message,
    };
  }
};
